import type { CountryAccessFormValues } from "./types";
import type { CountryAccess } from "@/partner/entities/countryAccesses";
import type {
  CreateCountryAccessInputType,
  UpdateCountryAccessInputType,
  CountryAccessTypeType,
} from "@/types/graphql/partner.generated";

/**
 * Maps GraphQL CountryAccess data to form values
 */
export const mapCountryAccessToFormValues = (
  item: CountryAccess | null | undefined
): CountryAccessFormValues => {
  if (!item) {
    return {
      title: "",
      type: "ALL",
      countries: [],
    };
  }

  return {
    title: item.title || "",
    type: item.type,
    countries: item.countries ?? [],
  };
};

/**
 * Maps form values to CreateCountryAccessInput for mutation
 */
export const mapFormValuesToCreateCountryAccessInput = (
  values: CountryAccessFormValues
): CreateCountryAccessInputType => {
  return {
    title: values.title,
    // Значения формы — плоский строковый union, бэкенд ждёт GraphQL-enum;
    // строки совпадают буквально, каст безопасен.
    type: values.type as CountryAccessTypeType,
    countries: values.type === "ALL" ? [] : values.countries,
  };
};

/**
 * Maps form values to UpdateCountryAccessInput for mutation
 */
export const mapFormValuesToUpdateCountryAccessInput = (
  values: CountryAccessFormValues
): UpdateCountryAccessInputType => {
  return {
    title: values.title,
    type: values.type as CountryAccessTypeType,
    countries: values.type === "ALL" ? [] : values.countries,
  };
};
